/*
 *  Copyright (C) 2019 schroeder.org - All Rights Reserved
 *  Unauthorized copying of this file or deriving works therefrom,
 *  via any medium, is strictly prohibited
 *  Proprietary and confidential
 *  <dev@schroeder.org>
 */

enum SubmissionStatus {
  Success = 'success',
  Failure = 'failure',
}

export default SubmissionStatus;
